module.exports = __webpack_public_path__ + "img/baby-growth.64b3b87a.webp";